export var ScaleAliasPrefix;
(function (ScaleAliasPrefix) {
    ScaleAliasPrefix["Space"] = "sp_";
    ScaleAliasPrefix["FontSizes"] = "fs_";
    ScaleAliasPrefix["LineHeights"] = "lh_";
})(ScaleAliasPrefix || (ScaleAliasPrefix = {}));
